export class User {
    id : number;
    parent: number;
    name: string;
    forname: string;
    email: string;
    street: string;
    town: string;
    zip: string;
    country: string;
    property1: string;
    property2: string;
    property3: string;
    property4: string;
    maxNumberOfTasks: number;
}


// WEBPACK FOOTER //
// ./src/providers/dto/user.ts